import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const NewAssignmentConfigurations = ({
  attachmentRequired,
  commentRequired,
  gradable,
  maxScore,
}) => {
  const { t } = useTranslation();

  return (
    <div className="configuration__wrapper">
      <div className="configuration__group">
        <div className="configuration__group__label">
          {t('File Submission')}
        </div>
        <div
          className="configuration__group__value"
          data-testid="requiresSubmission"
        >
          {attachmentRequired ? t('Yes') : t('No')}
        </div>
      </div>
      <div className="configuration__group">
        <div className="configuration__group__label">
          {t('Comment Submission')}
        </div>
        <div
          className="configuration__group__value"
          data-testid="requiresComment"
        >
          {commentRequired ? t('Yes') : t('No')}
        </div>
      </div>
      {gradable && (
        <div className="configuration__group">
          <div className="configuration__group__label">{t('Max Score')}</div>
          <div className="configuration__group__value" data-testid="maxScore">
            {maxScore}
          </div>
        </div>
      )}
    </div>
  );
};

export default NewAssignmentConfigurations;

NewAssignmentConfigurations.propTypes = {
  attachmentRequired: PropTypes.bool.isRequired,
  commentRequired: PropTypes.bool.isRequired,
  gradable: PropTypes.bool.isRequired,
  maxScore: PropTypes.number.isRequired,
};
